type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const ShowIcon = ({ iconColor, svgProps }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      {...svgProps}
    >
      <path
        d="M15.3954 3.77437C15.3354 3.69435 12.1345 0 8 0C5.3326 0 2.6652 1.48041 0.604629 3.77437C0.21569 4.19968 0 4.75514 0 5.33147C0 5.9078 0.21569 6.46326 0.604629 6.88857C3.57878 10.1695 6.52626 10.6696 8 10.6696C9.47374 10.6696 12.4479 10.1428 15.3954 6.88857C15.7843 6.46326 16 5.9078 16 5.33147C16 4.75514 15.7843 4.19968 15.3954 3.77437ZM14.4084 6.00165C14.3417 6.08168 11.4743 9.4226 8 9.33591C4.71243 9.25588 2.31843 6.80187 1.5849 6.00165C1.41807 5.81964 1.32553 5.5817 1.32553 5.3348C1.32553 5.0879 1.41807 4.84997 1.5849 4.66795C3.16533 2.93414 5.55266 1.28035 8 1.3337C10.9541 1.26702 13.6149 3.80105 14.4084 4.66795C14.5767 4.84925 14.6702 5.08745 14.6702 5.3348C14.6702 5.58215 14.5767 5.82036 14.4084 6.00165Z"
        fill={iconColor || '#131313'}
      />
      <path
        d="M8 2.6674H7.73993C7.71157 2.67026 7.68442 2.68035 7.66107 2.69669C7.63772 2.71304 7.61895 2.7351 7.60656 2.76076C7.59193 2.7861 7.58422 2.81485 7.58422 2.84412C7.58422 2.87338 7.59193 2.90213 7.60656 2.92747C7.74044 3.12814 7.81739 3.36136 7.82922 3.60231C7.84104 3.84325 7.7873 4.08288 7.67371 4.2957C7.56011 4.50851 7.39093 4.68653 7.18417 4.8108C6.97741 4.93507 6.74082 5.00093 6.49959 5.00138C6.19566 4.99925 5.90157 4.89338 5.66602 4.7013C5.64169 4.68725 5.6141 4.67985 5.586 4.67985C5.55791 4.67985 5.53031 4.68725 5.50598 4.7013C5.47884 4.70949 5.4545 4.72504 5.43567 4.74623C5.41683 4.76742 5.40424 4.79341 5.39928 4.82133C5.35856 4.98957 5.3362 5.16174 5.3326 5.3348C5.3326 5.86237 5.48904 6.37808 5.78214 6.81673C6.07523 7.25538 6.49183 7.59727 6.97923 7.79916C7.46663 8.00105 8.00296 8.05387 8.52038 7.95095C9.03781 7.84803 9.5131 7.59398 9.88614 7.22094C10.2592 6.8479 10.5132 6.37261 10.6161 5.85519C10.7191 5.33776 10.6662 4.80144 10.4644 4.31403C10.2625 3.82663 9.92058 3.41004 9.48193 3.11694C9.04328 2.82384 8.52756 2.6674 8 2.6674Z"
        fill={iconColor || '#131313'}
      />
    </svg>
  )
}
